// extracted by mini-css-extract-plugin
module.exports = {"container":"Placeholder_container__x53QS","top":"Placeholder_top__7SQQS","bottom":"Placeholder_bottom__2gSFH"};